import { Http, URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';
import { URL_SERVICIOS } from "../../config/url";
import 'rxjs/add/operator/map';

@Injectable()
export class CotizarProvider {

  constructor(public http: Http) {
    
  }

  cotizar(persona, vehiculo, tanque, cotizacion, tipo, email = "Si"):Promise<any>{
    return new Promise((resolve, reject) => {
      let url = URL_SERVICIOS + "cotizacion/cotizar/" + tipo;
      let data = new URLSearchParams();
      data.append('usuario', JSON.stringify(persona));
      data.append('vehiculo', JSON.stringify(vehiculo));
      data.append('tanque', JSON.stringify(tanque));
      data.append('cotizacion', JSON.stringify(cotizacion));
      data.append('email', email);
      console.log(JSON.stringify(persona));
      console.log(JSON.stringify(vehiculo));
      console.log(JSON.stringify(tanque));
      console.log(JSON.stringify(cotizacion));
      console.log(email);
      this.http.post(url, data)
      .map(resp => resp.json())
      .subscribe(data => {
        if(data.error){
          reject(data);
        }else{
          resolve(data);
        }
      },
      error => {
        console.error(error);
        reject(error);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/cotizar/cotizar.ts